let LOGIN_BASEURL = 'https://h5-login.81lianpin.com'
if(location.host === "learn.81lianpin.com" || location.host === "study.81lianpin.com" || location.host === 'studyone.81lianpin.com') {
  LOGIN_BASEURL = 'https://h5-login.81lianpin.com'
}else{
  LOGIN_BASEURL = 'http://test-login.81lianpin.com'
}
export {LOGIN_BASEURL}


// WEBPACK FOOTER //
// ./src/utils/utils.js